const accordions = document.querySelectorAll('[data-behaviour="accordion"]');


if( accordions.length > 0 ) {

    accordions.forEach((accordion) => {

        const toggle = accordion.querySelector('[data-behaviour="accordion__title"]');
        const content = accordion.querySelector('[data-behaviour="accordion__content"]');

        if( toggle && content ) {

            toggle.addEventListener('click', (e) => {

                e.preventDefault();
                e.stopImmediatePropagation();
                // if it's not this menu open, close the other one
                accordion.classList.toggle('is-active');
        
            });

        }

    });

}